<template>
  <div class="zzl-container">
    <div class="zzl-content">
      <div class="zzl-title">点餐报表</div>
      <div class="flex-between">
        <div class="zzl-search-list">
          <div class="zzl-search-item">
            <p>点餐时间</p>
            <el-date-picker
              v-model="search.date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              :clearable="false"
              @change="searchData"
            >
            </el-date-picker>
          </div>
          <div class="zzl-search-item">
            <p>点餐类型</p>
            <el-select
              v-model="search.meal_type"
              placeholder="请选择"
              @change="searchData"
            >
              <el-option
                v-for="item in mealTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="zzl-search-item">
            <el-button type="primary" @click="searchData">查询</el-button>
          </div>
        </div>
        <div class="zzl-search-list">
          <!-- <div class="zzl-search-item">
            <p></p>
            <el-select v-model="exportData.pageNum" placeholder="请选择">
              <el-option
                v-for="item in exportList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="zzl-search-item">
            <el-button type="primary" @click="exportExcel">导出</el-button>
          </div> -->
        </div>
      </div>
      <div class="zzl-table-list">
        <el-table
          ref="tableRef"
          :data="tableList"
          max-height="640px"
          style="width: 100%"
        >
          <el-table-column
            prop="name"
            label="菜名"
            min-width="250"
            align="center"
            fixed="left"
          >
          </el-table-column>
          <el-table-column
            prop="meal_count"
            label="点餐数量"
            min-width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="goods_amount"
            label="点餐是否截止"
            min-width="120"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.is_end == "1" ? "是" : "否" }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="flex-end-center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.pageNum"
            :page-size="pagination.pageSize"
            :total="pagination.count"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "orderReport",
  data() {
    return {
      tableList: [],
      pagination: {
        pageNum: 1,
        pageSize: 20,
        count: 0,
      },
      search: {
        date: this.getToday(),
        meal_type: "lunch",
      },
      mealTypeList: [
        {
          value: "lunch",
          label: "午餐",
        },
        {
          value: "supper",
          label: "晚餐",
        },
      ],
      exportData: {
        pageNum: 1,
        pageSize: 1000,
      },
      exportList: [],
    };
  },
  methods: {
    // 导出
    exportExcel() {
      if (this.pagination.count == 0) {
        this.$message.error("当前没有数据");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在导出中, 请等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.getList((res) => {
        res.forEach((item) => {
          item.type = item.is_end == "1" ? "是" : "否"
        });
        let tHeader = [];
        let filterVal = [];
        let columns = this.$refs.tableRef.columns;
        columns.forEach((item) => {
          tHeader.push(item.label);
          filterVal.push(item.property);
        });
        this.zzlFormat.exportExcel(
          tHeader,
          filterVal,
          res,
          "点餐信息表",
          loading
        );
      });
    },
    getExportList(count, size = 1000) {
      if (!count) {
        return
      }
      let list = [];
      let num = Math.floor(count / size);
      for (let i = 0; i < num; i++) {
        let item = {
          label: size * i + 1 + "~" + size * (i + 1) + "条",
          value: i + 1,
        };
        list.push(item);
      }
      let lastItem = {
        label: size * num + 1 + "~" + count + "条",
        value: num + 1,
      };
      list.push(lastItem);
      return list;
    },
    getToday() {
      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      let day = new Date().getDate();

      return `${year}-${month}-${day}`
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pagination.pageNum = 1;
      this.pagination.pageSize = val;
      this.getList();
    },
    searchData() {
      this.pagination.pageNum = 1;
      this.getList();
    },
    // 获取列表
    async getList(success) {
      let params = {
        // ...this.pagination,
        ...this.search,
      };
      if (success) {
        params = {
          ...params,
          ...this.exportData,
        };
      }
      const res = await this.zzlHttp.post(
        this.zzlApi.getMealReportList,
        params
      );
      if (res.code === 0 && Array.isArray(res.data)) {
        if (success) {
          success(res.data.list);
        } else {
          this.pagination.count = res.data.count || 0;
          this.tableList = res.data || [];
          // this.exportList = this.getExportList(res.data.count);
        }
      } else {
        this.tableList = [];
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
</style>
